import { makeRequest } from "../lib/makeRequest";

export const unredeemedpawn_overall = (data) =>
  makeRequest("/unredeemed-pawns/overall", { coveredDate: data.dates.from });

export const unredeemedpawn_cluster = (data) =>
  makeRequest(`/unredeemed-pawns/cluster/${data.clusterId}`, {
    coveredDate: data.dates.from,
  });

export const unredeemedpawn_area = (data) =>
  makeRequest(`/unredeemed-pawns/area/${data.areaId}`, {
    coveredDate: data.dates.from,
  });

export const unredeemedpawn_branch = (data) => {
  const urlParams = new URLSearchParams();
  urlParams.append("coveredDate", data.dates.from);
  return makeRequest(
    `/unredeemed-pawns/branches?${urlParams.toString()}`,
    data.branch_codes,
    "post"
  );
};
